<template>
    <div>
        <h1>Export</h1>
        <div class="row justify-content-center">
            <div class="col-sm-8">
                <div class="card">
                    <div class="card-body">
                        <div class="form-group">
                            <label>Server</label>
                            <div class="input-group">
                                <select
                                    v-model="server_address"
                                    class="form-control"
                                >
                                    <option
                                        v-for="server in servers"
                                        :key="server.address"
                                        :value="server.address"
                                    >
                                        {{
                                            server.name +
                                                ' –– ' +
                                                server.region +
                                                ' –– ' +
                                                server.address
                                        }}
                                    </option>
                                </select>
                            </div>
                        </div>

                        <div class="form-group">
                            <label>Country</label>
                            <div class="input-group">
                                <select v-model="region" class="form-control">
                                    <option
                                        v-for="country in countries"
                                        :key="country.code"
                                        :value="country.code"
                                    >
                                        {{ country.name }}
                                    </option>
                                </select>
                            </div>
                        </div>

                        <div class="form-group">
                            <label>Sticky</label>
                            <div class="input-group">
                                <select v-model="sticky" class="form-control">
                                    <option
                                        v-for="stickyOpt in stickyOpts"
                                        :key="stickyOpt.value"
                                        :value="stickyOpt.value"
                                    >
                                        {{ stickyOpt.label }}
                                    </option>
                                </select>
                            </div>
                        </div>

                        <small class="form-text text-muted"
                            >Disabled accounts are not included.</small
                        >
                    </div>

                    <div class="card-footer text-right">
                        <button class="btn btn-dark" @click="exportProxies">
                            Export
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import superagent from 'superagent'

import { config, auth, proxy, response, ad } from 'website-core'

const DEFAULT_COUNTRY = 'US'

export default {
    data() {
        let countries = null

        let stickyOpts = proxy.stickies.slice()
        stickyOpts.unshift({ label: 'All', value: -1 })

        return {
            server_address: null,
            servers: null,

            region: DEFAULT_COUNTRY,
            sticky: -1,

            countries: countries,
            stickyOpts: stickyOpts,
        }
    },
    async created() {
        let countries = await ad.region.get()
        countries.unshift({
            code: 'all',
            name: 'All',
        })
        this.countries = countries

        this.getServer()

        // this.countries
        // this.region = 'all'

        // this.stickyOpts
        // this.sticky = -1
    },
    methods: {
        getServer() {
            var self = this

            superagent
                .get(config.url_api + '/server')
                .query(auth.getAuthQs())
                .end(function(err, res) {
                    if (
                        response.ResHandle(
                            err,
                            res,
                            function() {},
                            self.$router
                        )
                    ) {
                        return
                    }

                    if (res.status != 200 || !res.body) {
                        response.ResShowErr(
                            'There was an unknown error. Please try again later'
                        )
                        return
                    }

                    self.servers = res.body

                    // default select
                    if (self.servers.length > 0) {
                        self.server_address = self.servers[0].address
                    }

                    return
                })
        },
        exportProxies() {
            if (!this.server_address) {
                return
            }

            const fb = auth.getAuthQs()

            window.open(
                config.url_api +
                    '/account/export?auth=' +
                    fb.auth +
                    '&access_token=' +
                    fb.access_token +
                    '&server=' +
                    this.server_address +
                    '&region=' +
                    this.region +
                    '&sticky=' +
                    this.sticky
            )
        },
    },
}
</script>